module.exports = __webpack_public_path__ + "static/media/callSignal.6c0526c3.svg";